// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tooltip-view[data-v-1e5835fa]{color:inherit;font-weight:400}.tooltip-view>div[data-v-1e5835fa]{margin:.1875rem 0}.tooltip-view>div[data-v-1e5835fa]:first-child{margin-top:0}.tooltip-view>div[data-v-1e5835fa]:last-child{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
